import React, { Component } from 'react';
import BaseLayout from '../../../templates/base';
import ProjectGoalCreateForm from '../../../elements/project/goal';
import Loading from '../../../elements/loading';
import GoalsAdd from '../../../elements/project/widgets/goals_add';

class GoalCreate extends Component {
	render() {
		const { project } = this.props;
		return (
			project.goals.isFetching ? <Loading/>:<ProjectGoalCreateForm {...this.props} />
		)
	}

	componentWillMount() {
		let { goal , modality, state, municipality } = this.props.match.params;
		this.props.projectProigualdadGoalsEdit(goal , modality, state, municipality);
	}
}

export default BaseLayout(GoalCreate, {
	title:"Editar Meta",
	subnav: {
		icon: 'fa-flag-checkered',
		name: 'Proigualdad',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <GoalsAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/project/goals/edit.jsx